var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [
                _vm._v(" " + _vm._s(_vm.$ct("titles.default")) + " "),
              ]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        {
                          style: { position: "relative" },
                          attrs: { xs: "12" },
                        },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.description"),
                              value: _vm.product.Name,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.sku"),
                              value: _vm.product.Sku,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.barcode"),
                              value: _vm.product.BarCode,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12", md: "6" } }, [
                        _c("div", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.activeText)),
                        ]),
                        _c("div", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.discountsAllowedText)),
                        ]),
                      ]),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("unit"),
                              value: _vm.unitName,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [
                _vm._v(_vm._s(_vm.$ct("titles.pricing_sales"))),
              ]),
              _c("app-sell-prices", { attrs: { product: _vm.product } }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [_c("app-product-info-groups", { attrs: { product: _vm.product } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }